import styled from "@emotion/styled";
import { NectarTheme } from "@nectarTypes";
import { Heading } from "nectar-ui";
import { css } from "@emotion/core";

type HeaderContainerCustomProps = {
  noShadow?: boolean;
  clickable?: boolean;
  asNav?: boolean;
};

export const HeaderContainer = styled.div<NectarTheme & HeaderContainerCustomProps>`
  ${({ theme, noShadow, clickable, asNav }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: ${noShadow ? "none" : "0px 0px 12px 0px rgba(0, 0, 0, 0.08)"};
    background-color: #fff;
    width: 100%;
    column-gap: ${theme.spacings.xs};
    max-height: 100px;

    & img {
      object-fit: contain;
      max-height: 72px;
    }

    ${clickable &&
    css`
      cursor: pointer;
    `}

    ${asNav &&
    css`
      position: absolute;
      left: 0;
      top: 0;
      height: 72px;
    `}
  `}
`;

export const TenantHeading = styled(Heading)<NectarTheme>`
  ${({ theme }) => css`
    letter-spacing: 0;
    text-align: center;
    color: ${theme.colors.gray500};
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
  `}
`;
